export interface ServerInfo {
  message: string
  time: string
}

export async function fetchServerInfo(): Promise<string> {
  try {
    const res = await fetch('/info')
    const data: ServerInfo = await res.json()
    return `${data.message} – ${data.time}`
  } catch {
    return '⚠ Fehler beim Laden der Serverinfo.'
  }
}
